
import { FC } from 'react';

import { AnchorProps, Anchor as AntdAnchor } from 'antd';

import './index.css';

interface CustomAnchorProps extends AnchorProps {
    containerId: string;
}

export const Anchor: FC<CustomAnchorProps> = ({ items, containerId }) => 
    <AntdAnchor 
        items={ items } 
        className='custom-anchor' 
        getContainer={ () => document.getElementById( containerId ) ?? window }
        affix={ false }
        bounds={100}
        offsetTop={20}
    />;
